import { matrixAutoCorrelation } from 'ml-spectra-processing';
export function getAutocorrelation(normalized, index) {
    return {
        x: normalized.x,
        y: matrixAutoCorrelation(normalized.matrix, index),
    };
}
//# sourceMappingURL=getAutocorrelation.js.map